import { render, staticRenderFns } from "./LandingFrame.vue?vue&type=template&id=8c7ebffe"
import script from "./LandingFrame.vue?vue&type=script&lang=js"
export * from "./LandingFrame.vue?vue&type=script&lang=js"
import style0 from "./LandingFrame.vue?vue&type=style&index=0&id=8c7ebffe&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c7ebffe')) {
      api.createRecord('8c7ebffe', component.options)
    } else {
      api.reload('8c7ebffe', component.options)
    }
    module.hot.accept("./LandingFrame.vue?vue&type=template&id=8c7ebffe", function () {
      api.rerender('8c7ebffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/landing/components/LandingFrame.vue"
export default component.exports